// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import NavigationBar from "../../Components/NavigationBar";
// import axios from "axios";

// export default function SendEmailMC() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;

//   const { applicationId, awardType } = location.state || {};
//   const [recipientName, setRecipientName] = useState("");
//   const [recipientEmail, setRecipientEmail] = useState("");
//   const [emailSubject, setEmailSubject] = useState("");
//   const [emailBody, setEmailBody] = useState("");

//   // Generate email link for a single application
//   const emailLink = applicationId
//   ? `${FRONTEND_BASE_URL}/mcmemberapprove?applicationId=${applicationId}&role=MCMember`
//   : "";

//   // Set default email subject and body when component loads
//   useEffect(() => {
//     if (applicationId && awardType) {
//       const subject = `Verification and Approval of Faculty Application: ${awardType}`;
//       setEmailSubject(subject);
//       const defaultBody = `Dear MC member of the URC,\n\nThis application has been submitted by one of your faculty members. We kindly request that you verify whether the applicant’s h-index, as listed on their Google Scholar profile, meets the requirements outlined in UGC Circular 05/2018. Additional details are available in our Grant and Award Management System.\n\nIf the applicant satisfies the eligibility criteria, please approve the application by clicking the ‘Approve’ button in the system. We request that this action be completed within seven (7) days of receiving this email.\n\nView application: ${emailLink}\n\nThank you for your prompt attention to this matter.\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;
//       setEmailBody(defaultBody);
//     }
//   }, [applicationId, awardType, recipientName]);

//   const handleSendEmail = async () => {
//     if (!recipientName || !recipientEmail) {
//       alert("Please fill in recipient name and email.");
//       return;
//     }
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
//       alert("Please enter a valid email address.");
//       return;
//     }

//     const updatedEmailBody = `Dear MC member of the URC,\n\nThis application has been submitted by one of your faculty members. We kindly request that you verify whether the applicant’s h-index, as listed on their Google Scholar profile, meets the requirements outlined in UGC Circular 05/2018. Additional details are available in our Grant and Award Management System.\n\nIf the applicant satisfies the eligibility criteria, please approve the application by clicking the ‘Approve’ button in the system. We request that this action be completed within seven (7) days of receiving this email.\n\nView application: ${emailLink}\n\nThank you for your prompt attention to this matter.\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;

//     try {
//       // Save email details for the application
//       await axios.post(`${API_BASE_URL}/saveMCMemberEmailDetails`, {
//         App_Id: applicationId,
//         McMember_Name: recipientName,
//         McMember_Email: recipientEmail,
//         Sent: 1,
//       });

//       // Simulate email sending (replace with actual email sending logic)
//       alert("Email sent successfully!");
//       navigate("/approveawardsmc");
//     } catch (error) {
//       console.error("Failed to save email record:", error);
//       alert("Failed to send email. Please try again.");
//     }
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="container mt-4">
//         <h2 className="page-name">Send Email to MC Member</h2>
//         <Form>
//           <Form.Group className="mb-3">
//             <Form.Label>Award Type</Form.Label>
//             <Form.Control type="text" value={awardType || ""} readOnly />
//           </Form.Group>
         
//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Name</Form.Label>
//             <Form.Control
//               type="text"
//               value={recipientName}
//               onChange={(e) => setRecipientName(e.target.value)}
//               placeholder="Enter recipient's name"
//             />
//           </Form.Group>
//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Email</Form.Label>
//             <Form.Control
//               type="email"
//               value={recipientEmail}
//               onChange={(e) => setRecipientEmail(e.target.value)}
//               placeholder="Enter recipient's email"
//             />
//           </Form.Group>
//           <Form.Group className="mb-3">
//             <Form.Label>Email Subject</Form.Label>
//             <Form.Control
//               type="text"
//               value={emailSubject}
//               onChange={(e) => setEmailSubject(e.target.value)}
//             />
//           </Form.Group>
//           <Form.Group className="mb-3">
//             <Form.Label>Email Body</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={10}
//               value={emailBody}
//               onChange={(e) => setEmailBody(e.target.value)}
//             />
//           </Form.Group>
//           <div className="mb-3">
//             <p className="emaillink" style={{ color: "black" }}>
//               <strong>Email Link (For Sender's Reference):</strong>
//             </p>
//             <a
//               href={emailLink}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "black" }}
//             >
//               {emailLink}
//             </a>
//           </div>
//           <Button
//             variant="primary"
//             className="Send_Button"
//             onClick={handleSendEmail}
//             disabled={!applicationId || !awardType}
//           >
//             Send
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import NavigationBar from "../../Components/NavigationBar";
import axios from "axios";

export default function SendEmailMC() {
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || 'http://localhost:3000';

  const { applicationId, awardType } = location.state || {};
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");

  // Generate email link for a single application
  const emailLink = applicationId
    ? `${FRONTEND_BASE_URL}/mcmemberapprove?applicationId=${applicationId}&role=MCMember`
    : "";

  // Set default email subject and body when component loads
  useEffect(() => {
    if (applicationId && awardType) {
      const subject = `Verification and Approval of Faculty Application: ${awardType}`;
      setEmailSubject(subject);
      const defaultBody = `Dear MC member of the URC,\n\nThis application has been submitted by one of your faculty members. We kindly request that you verify whether the applicant’s h-index, as listed on their Google Scholar profile, meets the requirements outlined in UGC Circular 05/2018. Additional details are available in our Grant and Award Management System.\n\nIf the applicant satisfies the eligibility criteria, please approve the application by clicking the ‘Approve’ button in the system. We request that this action be completed within seven (7) days of receiving this email.\n\nView application: ${emailLink}\n\nThank you for your prompt attention to this matter.\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;
      setEmailBody(defaultBody);
    }
  }, [applicationId, awardType, recipientName]);

  const handleSendEmail = async () => {
    if (!recipientName || !recipientEmail) {
      alert("Please fill in recipient name and email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      // Save email details for the application
      await axios.post(`${API_BASE_URL}/saveMCMemberEmailDetails`, {
        App_Id: applicationId,
        McMember_Name: recipientName,
        McMember_Email: recipientEmail,
        Sent: 1,
      });

      // Send email via nodemailer
      const response = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: recipientEmail,
        subject: emailSubject,
        text: emailBody,
        html: `<p>${emailBody.replace(/\n/g, '<br>')}</p>`,
      });

      alert(response.data.message); // "Email sent successfully"
      navigate("/approveawardsmc");
    } catch (error) {
      console.error("Failed to send email:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <div className="container mt-4">
        <h2 className="page-name">Send Email to MC Member</h2>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Award Type</Form.Label>
            <Form.Control type="text" value={awardType || ""} readOnly />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Recipient Name</Form.Label>
            <Form.Control
              type="text"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              placeholder="Enter recipient's name"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Recipient Email</Form.Label>
            <Form.Control
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="Enter recipient's email"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Subject</Form.Label>
            <Form.Control
              type="text"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Body</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
            />
          </Form.Group>
          <div className="mb-3">
            <p className="emaillink" style={{ color: "black" }}>
              <strong>Email Link (For Sender's Reference):</strong>
            </p>
            <a
              href={emailLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {emailLink}
            </a>
          </div>
          <Button
            variant="primary"
            className="Send_Button"
            onClick={handleSendEmail}
            disabled={!applicationId || !awardType}
          >
            Send
          </Button>
        </Form>
      </div>
    </div>
  );
}